export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_03-d5594db6a25b33fca8f85b1dc3966c53.jpg";